import { render, staticRenderFns } from "./AGResetUserPassword.vue?vue&type=template&id=3a17e6ca&"
import script from "./AGResetUserPassword.vue?vue&type=script&lang=js&"
export * from "./AGResetUserPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports